export const JackpotTypes = {
	FETCH_JACKPOT_DETAILS: 'FETCH_JACKPOT_DETAILS',
	SET_JACKPOT_DETAILS: 'SET_JACKPOT_DETAILS',
	FETCH_JACKPOT_WINNERS: 'FETCH_JACKPOT_WINNERS',
	SET_JACKPOT_WINNERS: 'SET_JACKPOT_WINNERS'

}